<template>
    <!-- the search open at the start like every list's TableFilters bar (tasks#211) -->
    <div class="dd-filter-bar dd-filter-bar--search-first">
        <search-box
            v-model="tableFilters"
            class="dd-filter-bar__search"
            :label="$t('labels.search')"
        ></search-box>
        <filter-box
            v-if="!hideFilterBox"
            v-model="tableFilters"
            :fields="fields"
            :add-id-filter="addIdFilter"
        ></filter-box>
        <slot></slot>
    </div>
</template>

<script>
import SearchBox from './SearchBox'
import FilterBox from './FilterBox'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'

export default {
    components: {
        SearchBox,
        FilterBox,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
        busy: {
            type: Boolean,
        },
        hideFilterBox: {
            type: Boolean,
        },
        addIdFilter: {
            type: Boolean,
        },
    },
    data() {
        return {
            tableFilters: {},
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(value) {
                if (!isEqual(value, this.tableFilters)) {
                    this.tableFilters = cloneDeep(value)
                }
            },
        },
        tableFilters: {
            deep: true,
            handler(value) {
                this.$emit('input', cloneDeep(value))
            },
        },
    },
}
</script>
